module.exports = __webpack_public_path__ + "static/media/XinGuan.906fc740.jpg";